export default __webpack_public_path__ + "1a9501b39ef9ee7e034feebda856b7ba.svg";